import LICENCE_TYPES from "../_constants/licenceTypes";


/**
 * Returns "Bob Dylan", "Bob", "Dylan" or "" depending what data exists
 * @param {any} userInfo  object with data firstName and lastName
 * @returns {string}
 */
export function getFullName(userInfo)
{
    return [userInfo?.firstName, userInfo?.lastName].filter((s) => s).join(" ");
}

export function getLicenceDetailsByName(name)
{
    const extraLicences = [
        {name: "company_admin", title: "Company Admin"}
    ];
    return [...LICENCE_TYPES,...extraLicences].find((item) => item.name === name);
}

